// Shared import() functions for the two DU Daily booking-flow chunks, so
// App.js's lazy() and DriveULandingPage's prefetch-on-mount both resolve to
// the exact same chunk (not a duplicate fetch). Called early from the
// landing page so the chunk is already cached by the time the user picks
// Round Trip / One Way, instead of showing a loader on that transition.
export const importDriveuDaily = () =>
  import("../pages/DriveuDaily/DriveuDaily");

export const importDUOneWayBooking = () =>
  import("../DriveUDaily/DUOneWayBooking/DUOneWayBooking");
